<div class="cart-info-box mt-5">
  <p>
    <span>{{ "CART.ORDER_NUMBER" | translate }}: </span>
    <span class="bold">{{ cart.id }}</span>
  </p>

  <p class="cart-item" *ngFor="let item of cart.additionalItems" >
    <span>{{ item.description }}:</span>
    <span class="bold nowrap"> {{ item.basePrice }} {{ item.currency }}</span>
  </p>

  <p class="total-info-price">
    <span>{{ "CART.TOTAL" | translate }}:</span>
    <span class="bold"> {{ cart.totalPrice }} {{ cart.currency }}</span>
  </p>
</div>
